import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="blob" id="blob"></a>
    <h1 {...{
      "id": "windowblob"
    }}>{`window.Blob`}</h1>
    <p><strong parentName="p">{`Since`}</strong>{`: UXP v6.3  `}</p>
    <a name="new-blob-new" id="new-blob-new"></a>
    <h2 {...{
      "id": "blobarray-options"
    }}>{`Blob(array, `}{`[options]`}{`)`}</h2>
    <p>{`The Blob object represents a blob, which is a file-like object of immutable, raw data;
they can be read as text or binary data, or converted into a `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/ReadableStream"
      }}>{`ReadableStream`}</a>{`
so its methods can be used for processing the data.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: New Blob object which contains a concatenation of all of the data in the array passed into the constructor.  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`array`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Array`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Iterable object such as an Array, having ArrayBuffers, TypedArrays, DataViews, Blobs, strings, or a mix of any of such elements, that will be put inside the Blob. Note that strings here are encoded as UTF-8, unlike the usual JavaScript UTF-16 strings.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[options]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`(optional)`}</inlineCode>{` Object which may specify any of the following properties:`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[options.type]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`(optional)`}</inlineCode>{` MIME type of the data that will be stored into the blob. The default value is the empty string, ("").`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[options.endings]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`(optional)`}</inlineCode>{` How to interpret newline characters (\\n) within the contents, if the data is text. The default value, transparent, copies newline characters into the blob without changing them. To convert newlines to the host system's native convention, specify the value native.`}</td>
        </tr>
      </tbody>
    </table>
    <a name="blob-size" id="blob-size"></a>
    <h2 {...{
      "id": "size--number"
    }}>{`size : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
Size of the Blob in bytes.`}</p>
    <a name="blob-type" id="blob-type"></a>
    <h2 {...{
      "id": "type--string"
    }}>{`type : `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
MIME type of the Blob.`}</p>
    <a name="blob-arraybuffer" id="blob-arraybuffer"></a>
    <h2 {...{
      "id": "arraybuffer"
    }}>{`arrayBuffer()`}</h2>
    <p>{`Get the contents of the Blob in the form of an ArrayBuffer.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Promise<ArrayBuffer>`}</inlineCode>{` Promise that resolves with an ArrayBuffer that contains the blob's data in binary form.  `}</p>
    <a name="blob-slice" id="blob-slice"></a>
    <h2 {...{
      "id": "slicestart-end-contenttype"
    }}>{`slice(`}{`[start]`}{`, `}{`[end]`}{`, `}{`[contentType]`}{`)`}</h2>
    <p>{`Get a portion of the Blob's data selected from start to end (end not included).`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Blob`}</inlineCode>{` - New Blob object containing the specified subset of the data contained with the blob on which this method was called.
The original blob is not altered.  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[start]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`0`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`(Optional)`}</inlineCode>{` Index into the Blob indicating the first byte to include in the new Blob`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[end]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`size`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`(Optional)`}</inlineCode>{` Index into the Blob indicating the first byte that will NOT be included in the new Blob`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[contentType]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`&quot;\\&quot;\\&quot;&quot;`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`(Optional)`}</inlineCode>{` String containing the file's `}<a parentName="td" {...{
              "href": "https://developer.mozilla.org/en-US/docs/Glossary/MIME_type"
            }}>{`MIME type`}</a>{`, or empty string if the type could not be determined. Refer `}<a parentName="td" {...{
              "href": "https://developer.mozilla.org/en-US/docs/Web/API/Blob/type#value"
            }}>{`Blob.type`}</a></td>
        </tr>
      </tbody>
    </table>
    <a name="blob-stream" id="blob-stream"></a>
    <h2 {...{
      "id": "stream"
    }}>{`stream()`}</h2>
    <p>{`Get the data contained within the Blob as a ReadableStream.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`ReadableStream`}</inlineCode>{` - Content of the Blob.  `}</p>
    <a name="blob-text" id="blob-text"></a>
    <h2 {...{
      "id": "text"
    }}>{`text()`}</h2>
    <p>{`Get contents of the Blob as a string.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Promise<string>`}</inlineCode>{` Promise that resolves with a string which contains the blob's data as a text string.
The data is always presumed to be in UTF-8 format.  `}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      